<template>
	<div>
		<div class="columns contact-details is-vcentered">
			<div
				class="column is-narrow is-hidden-touch is-hidden-desktop-only"
			>
				<avatar
					:image="user.image"
					:cropped="true"
					:alt="fullName"
					:size="size"
				/>
			</div>
			<div class="column">
				<p class="title is-4 is-marginless" v-text="fullName" />
				<p
					v-if="jobtitle"
					class="subtitle is-6 is-marginless"
					v-text="jobtitle"
				/>
				<p v-if="showDetails" class="user-details">
					<a v-if="emailLink" :href="emailLink">{{ user.email }}</a>
					<br v-if="emailLink && phoneLink" />
					<dc-icon
						v-if="phoneLink"
						icon="phone-alt"
						library="fas"
					></dc-icon
					><a v-if="phoneLink" :href="phoneLink">{{ user.phone }}</a>
					<br v-if="pagerLink && phoneLink" />
					<a v-if="pagerLink" :href="pagerLink">{{
						user.pagernumber
					}}</a>
				</p>
				<p v-if="showViewLink">
					<router-link
						:to="`/users/view/${user.id}`"
						class="button is-small"
						>View profile</router-link
					>
				</p>
			</div>
		</div>
	</div>
</template>
<script>
import Avatar from "@shared/components/AppAvatar";

export default {
	components: {
		Avatar
	},
	props: {
		user: {
			type: Object,
			required: true
		},
		showDetails: {
			type: Boolean,
			default: true
		},
		size: {
			type: String,
			default: () => "is-128x128"
		},
		showViewLink: {
			type: Boolean,
			default: () => false
		}
	},
	computed: {
		fullName() {
			return this.user.firstname + " " + this.user.lastname;
		},
		emailLink() {
			return this.user.email ? "mailto:" + this.user.email : null;
		},
		phoneLink() {
			return this.user.phone ? "tel:" + this.user.phone : null;
		},
		pagerLink() {
			return this.user.pagernumber
				? "tel:" + this.user.pagernumber
				: null;
		},
		jobtitle() {
			return this.user.jobtitle;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "~@lab/styles/scss/utilities/tokens";

.contact-details {
	width: 100%;
	min-width: 350px;
}
.user-details {
	font-size: 0.9rem;
}
a {
	color: $colour-black;

	&:hover {
		color: $colour-pink;
	}

	&[href*="tel:"] {
		// @include from($media-tablet) {
		// 	cursor: default;
		// 	pointer-events: none;
		// 	color: $text-color;
		// }
	}
}
</style>
